import React from "react";
import { Card, Row, Col } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { FiTrendingUp } from "react-icons/fi";
import "../../containers/SpAndSuAnalysis/style.css";

const StatCard = ({ title, current, previous, percentage, isYearly = false }) => {
    const increased = percentage >= 0;
    const label = isYearly ? "This Year" : "This Month";

    return (
        <Card className="stat-card">
            <div className="stat-header">
                <h4 className="stat-title">{title}</h4>
            </div>
            <div className="stat-body">
                <div className="stat-value">
                    {title.toLowerCase().includes("revenue")
                        ? `£${current?.toLocaleString()}`
                        : current}
                </div>
                <div className={`stat-change ${increased ? "up" : "down"}`}>
                    {increased ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                    <span>{Math.abs(percentage).toFixed(1)}%</span>
                </div>
            </div>
            <div className="stat-footer">
                <p className="stat-label">{label}</p>
                <p className="stat-previous">
                    Previous:{" "}
                    {title.toLowerCase().includes("revenue")
                        ? `£${previous?.toLocaleString()}`
                        : previous}
                </p>
            </div>
        </Card>
    );
};

const PerformanceComparison = ({ data }) => {
    const mappedData = data
        ? [
            {
                title: "Month-over-Month Bookings",
                current: data.monthOverMonthBookings.current,
                previous: data.monthOverMonthBookings.previous,
                percentage: data.monthOverMonthBookings.change,
            },
            {
                title: "Month-over-Month Revenue",
                current: data.monthOverMonthRevenue.current,
                previous: data.monthOverMonthRevenue.previous,
                percentage: data.monthOverMonthRevenue.change,
            },
            {
                title: "Year-over-Year Bookings",
                current: data.yearOverYearBookings.current,
                previous: data.yearOverYearBookings.previous,
                percentage: data.yearOverYearBookings.change,
                isYearly: true,
            },
            {
                title: "Year-over-Year Revenue",
                current: data.yearOverYearRevenue.current,
                previous: data.yearOverYearRevenue.previous,
                percentage: data.yearOverYearRevenue.change,
                isYearly: true,
            },
        ]
        : [];

    return (
        <div className="stats-grid">
            <div className="chart-header">
                <div className="chart-header-left">
                    <FiTrendingUp className="chart-icon" size={20} />
                    <h3 className="chart-title">Performance Comparison</h3>
                </div>
            </div>
            <Row gutter={[16, 16]}>
                {mappedData.map((item, index) => (
                    <Col key={index} xs={24} sm={12} md={12} lg={12}>
                        <StatCard {...item} />
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default PerformanceComparison;
